// extracted by mini-css-extract-plugin
export default {"content":"q4wVXVB3zTyedJoPI8gD__content___","footer":"oeR8hq7R3F1YuIVG1ilp__footer___"};